import React, { useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { routesConfig } from '../configs/route-config';
import NoDataFound from '../pages/no-data-found';
import { isValidArray } from '../utils/is-array';
import AuthenticationRoute from './AuthenticationRoute';
import { useDispatch } from 'react-redux';
import { logoutUser, validateToken } from '../store/login/action';
import { parseLocationSearchParams } from '../utils/helpers/parse-location-search-params';
import saveCookie from '../utils/helpers/save-cookie';
import { COOKIE_KEYS } from '../constants/app-constants';
import { ROUTE_PATH } from '../constants/route-constants';
import { proxyAuthState } from '../services/user-auth-api';

const AppConfigurations = () => {
    const publicRoutes = routesConfig.filter(route => route.isPublic);
    const protectedRoutes = routesConfig.filter(route => !route.isPublic);
    const { token } = parseLocationSearchParams(window?.location?.search);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        checkUserLoggedIn();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const navigatePostLogin = (tokenResponse) => {
        saveCookie(COOKIE_KEYS.ACCESS_TOKEN, tokenResponse?.access_token);
        if (window.location.pathname === ROUTE_PATH.LOGIN) {
            navigate(ROUTE_PATH.EXPLORE);
        }
    };

    const navigateToLogout = () => {
        if (window.location.pathname !== ROUTE_PATH.LOGIN) {
            navigate(ROUTE_PATH.LOGIN);
        }
    };

    const checkUserLoggedIn = () => {
        if (token) {
            dispatch(validateToken(token)).then((response) => {
                navigatePostLogin(response);
            }).catch(() => {
                proxyAuthState.accessToken = null;
                proxyAuthState.isLoggedIn = false;
                dispatch(logoutUser());
                navigateToLogout();
            });
            return;
        }
        navigateToLogout();
    };

    return (
        <Routes>
            {isValidArray(publicRoutes) &&
                publicRoutes.map((route, index) => (
                    <Route key={index} {...route} />
                ))
            }
            {isValidArray(protectedRoutes) && <Route element={<AuthenticationRoute />}>
                {
                    protectedRoutes.map((route, index) => (
                        <Route key={index} {...route} />
                    ))
                }
            </Route>}
            <Route path='*' element={<NoDataFound />} />
        </Routes>
    );
};

export default AppConfigurations;
